<template>
  <div>
    <div>
      <span class="selected_lable">日期选择：</span>
      <el-date-picker
        v-model="durationStart"
        align="right"
        type="date"
        placeholder="选择日期"
        @change="durationChange"
        :clearable="isClear">
      </el-date-picker>
      -
      <el-date-picker
        v-model="durationEnd"
        align="right"
        type="date"
        placeholder="选择日期"
        @change="durationChange"
        :clearable="isClear">
      </el-date-picker>
      &nbsp;
      &nbsp;
      选择医院：
      <el-select v-model="hospitalId" placeholder="请选择医院" @change="selectHospital">
        <el-option
          v-for="item in hospitalList"
          :key="item.hospitalId"
          :label="item.hospitalName"
          :value="item.hospitalId">
        </el-option>
      </el-select>
      &nbsp;
      &nbsp;
      总人数：{{this.totalMale + this.totalFemale}} 人（男：{{this.totalMale}} , 女：{{this.totalFemale}}）
    </div>
    <div>
      <div id="main" style="height: 640px">
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import Global from "../Global";

export default {
  name: "PlaqueCountThree",
  props: {
    hospital: String,
    hospitals: Array
  },
  data () {
    return {
      myChart: null,
      qc1Data: [],
      qc2Data: [],
      qc3Data: [],
      isClear: false,
      durationStart: new Date(1640966400000),
      durationEnd: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
      hospitalList: this.hospitals,
      hospitalId: this.hospital,
      total: 0,
      totalMale: 0,
      totalFemale: 0
    }
  },
  mounted() {
    this.getAllData()
  },
  methods: {
    // 选择医院
    selectHospital () {
      this.$emit('changeHospital', this.hospitalId)
      this.getAllData()
    },
    // 选择时间段
    durationChange () {
      this.getAllData()
    },
    async getAllData () {
      this.qc1Data = []
      this.qc2Data = []
      this.qc3Data = []
      // 获取各个年龄段男性的数据
      let data1 = await this.getData(0, 40, 1)
      let data2 = await this.getData(41, 50, 1)
      let data3 = await this.getData(51, 60, 1)
      let data4 = await this.getData(61, 70, 1)
      let data5 = await this.getData(71, 80, 1)
      let data6 = await this.getData(81, 100, 1)
      this.total = data1.total + data2.total + data3.total + data4.total + data5.total + data6.total
      let maleData = await this.getData(0, 150, 1)
      this.totalMale = maleData.normal + maleData.qc1 + maleData.qc2 + maleData.qc3
      // 放入男性病历数据
      this.qc1Data.push(((data1.qc1 + data1.qc2 + data1.qc3)  / this.totalMale * 100).toFixed(2))
      this.qc1Data.push(((data2.qc1 + data2.qc2 + data2.qc3) / this.totalMale * 100).toFixed(2))
      this.qc1Data.push(((data3.qc1 + data3.qc2 + data3.qc3) / this.totalMale * 100).toFixed(2))
      this.qc1Data.push(((data4.qc1 + data4.qc2 + data4.qc3) / this.totalMale * 100).toFixed(2))
      this.qc1Data.push(((data5.qc1 + data5.qc2 + data5.qc3) / this.totalMale * 100).toFixed(2))
      this.qc1Data.push(((data6.qc1 + data6.qc2 + data6.qc3) / this.totalMale * 100).toFixed(2))
      // 获取各个年龄段男性的数据
      let data7 = await this.getData(0, 40, 0)
      let data8 = await this.getData(41, 50, 0)
      let data9 = await this.getData(51, 60, 0)
      let data10 = await this.getData(61, 70, 0)
      let data11 = await this.getData(71, 80, 0)
      let data12 = await this.getData(81, 100, 0)
      let femaleData = await this.getData(0, 150, 0)
      this.totalFemale = femaleData.normal + femaleData.qc1 + femaleData.qc2 + femaleData.qc3
      // 放入女性病历数据
      this.qc2Data.push(((data7.qc1 + data7.qc2 + data7.qc3)  / this.totalFemale * 100).toFixed(2))
      this.qc2Data.push(((data8.qc1 + data8.qc2 + data8.qc3) / this.totalFemale * 100).toFixed(2))
      this.qc2Data.push(((data9.qc1 + data9.qc2 + data9.qc3) / this.totalFemale * 100).toFixed(2))
      this.qc2Data.push(((data10.qc1 + data10.qc2 + data10.qc3) / this.totalFemale * 100).toFixed(2))
      this.qc2Data.push(((data11.qc1 + data11.qc2 + data11.qc3) / this.totalFemale * 100).toFixed(2))
      this.qc2Data.push(((data12.qc1 + data12.qc2 + data12.qc3) / this.totalFemale * 100).toFixed(2))
      this.initChart()
    },
    // 获取数据
    async getData (startAge, endAge, sex) {
      let durationStart = this.durationStart.getTime()
      let durationEnd = this.durationEnd.getTime() + 1000 * 60 * 60 * 24
      if (durationStart > durationEnd) {
        this.$message.error('结束时间不能小于开始时间')
        return
      }
      let that = this
      let resp = await this.axios({
        method: 'GET',
        url: Global.yunyingUrl + '/service-order/order/countOrderLevelAll?durationStart=' + durationStart + '&durationEnd=' +
          durationEnd + '&hospitalId=' + that.hospitalId + '&startAge=' + startAge + '&endAge=' + endAge + '&sex=' + sex
      })
      if (resp.data.code === 1000) {
        return resp.data.data
      }
    },
    // 初始化图表
    initChart () {
      // 如果存在实例需要进行销毁
      if (this.myChart != null) {
        this.myChart.dispose()
      }
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.getElementById('main'))

      // 指定图表的配置项和数据
      let option = {
        title: {
          text: '斑块阳性性别病患占比图',
          left: 600
        },
        legend: {
          top: '5%',
          right: '0%',
          orient: 'vertical'
        },
        xAxis: {
          type: 'category',
          data: ['0-40岁', '40-50岁', '50-60岁', '60-70岁', '70-80岁', '80岁以上']
        },
        yAxis: {
          name: '阳性率（单位：%)'
        },
        series: [
          {
            name: '男',
            data: this.qc1Data,
            type: 'bar',
            stack: 'x',
            label: {
              show: true,
              formatter: function (params) {
                if (params.value == 0) {  //为0时不显示
                  return ''
                } else {
                  return params.value + '%'
                }
              },
              fontWeight: 'bold'
            }
          },
          {
            name: '女',
            data: this.qc2Data,
            type: 'bar',
            stack: 'x',
            label: {
              show: true,
              formatter: function (params) {
                if (params.value == 0) {  //为0时不显示
                  return ''
                } else {
                  return params.value + '%'
                }
              },
              fontWeight: 'bold'
            }
          }
        ]
      }

      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/plaque_count/PlaqueCountThree.vue